var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24591 8.83495C4.12954 8.83491 4.01432 8.81193 3.90684 8.76731C3.79936 8.7227 3.70173 8.65733 3.61955 8.57495L0.275 5.22922C0.118432 5.0612 0.0331959 4.83896 0.0372475 4.60933C0.041299 4.3797 0.134322 4.16061 0.296719 3.99821C0.459117 3.83582 0.678208 3.74279 0.907837 3.73874C1.13747 3.73469 1.3597 3.81993 1.52773 3.9765L4.24591 6.69468L10.3205 0.621313C10.4885 0.464746 10.7107 0.379509 10.9403 0.383561C11.17 0.387612 11.3891 0.480636 11.5515 0.643033C11.7139 0.80543 11.8069 1.02452 11.8109 1.25415C11.815 1.48378 11.7297 1.70602 11.5732 1.87404L4.87227 8.57495C4.79008 8.65733 4.69246 8.7227 4.58498 8.76731C4.4775 8.81193 4.36228 8.83491 4.24591 8.83495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdded);
export default __webpack_public_path__ + "static/media/added.cbc6e6cc53c961c2e0aa02dd795ba9f1.svg";
export { ForwardRef as ReactComponent };